var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-by"},[_c('p',[_vm._v(" Order by: "),_c('span',{on:{"click":_vm.handleSort}},[_vm._v("Name")])])])}
var staticRenderFns = []

export { render, staticRenderFns }